/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdRolesMutationRequest,
  PutApiV1PersonIdRolesMutationResponse,
  PutApiV1PersonIdRolesPathParams,
  PutApiV1PersonIdRoles400,
  PutApiV1PersonIdRoles401,
  PutApiV1PersonIdRoles404,
  PutApiV1PersonIdRoles500,
} from "../../types/personRegisterController/PutApiV1PersonIdRoles.ts";

function getPutApiV1PersonIdRolesUrl(
  id: PutApiV1PersonIdRolesPathParams["id"],
) {
  const res = { method: "PUT", url: `/api/v1/person/${id}/roles` as const };
  return res;
}

/**
 * @description Atualiza parcialmente os papéis da pessoa. Apenas as flags informadas serão alteradas. **(Requer Authorization para autenticação)**
 * @summary Atualizar papéis da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/roles}
 */
export async function putApiV1PersonIdRoles(
  id: PutApiV1PersonIdRolesPathParams["id"],
  data?: PutApiV1PersonIdRolesMutationRequest,
  config: Partial<RequestConfig<PutApiV1PersonIdRolesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdRolesMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdRoles400
      | PutApiV1PersonIdRoles401
      | PutApiV1PersonIdRoles404
      | PutApiV1PersonIdRoles500
    >,
    PutApiV1PersonIdRolesMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdRolesUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
